// Format currency for display.
// currency/locale default to GBP/en-GB so existing callers are unchanged.
export const formatCurrency = (
    amount: number,
    currency: string = 'GBP',
    locale: string = 'en-GB',
): string => {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
};
